import React from "react";

const SvgClock = props => <svg viewBox="0 0 20 20" {...props}><g fill="none" fillRule="evenodd"><path fill="#9AA7B1" d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8" /><path fill="#603276" d="M11 9.586V5a1 1 0 1 0-2 0v5c0 .266.105.52.293.707l3 3a.996.996 0 0 0 1.414 0 1 1 0 0 0 0-1.414L11 9.586z" /></g></svg>;

export default SvgClock;